export enum LogoTypes {
    LOGO_WHITE = "Logo White",
    LOGO_COLOR = "Logo Color"
}